exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pagaende+.btn-label:before,#procent+.btn-label:before{content:\"\";width:100%;height:100%;position:absolute;top:0;left:100%;z-index:-1;background-color:#7fb17f;transition:all .3s ease;border-radius:15px}#pagaende:checked+.btn-label:before,#procent:checked+.btn-label:before{left:0}#antal:checked+.btn-label,#pagaende:checked+.btn-label,#procent:checked+.btn-label,#startar:checked+.btn-label{color:#fff}.input_date{width:100%!important}.my_spacer{width:20px}#button_fetch{margin-top:90px}.explaining_text{font-size:18px;text-align:center}#laddtext{margin-left:calc(50% - 100px);top:500px;width:200px;height:50px;background-color:hsla(0,0%,100%,.8);color:#f83;font-size:20px;text-align:center;padding-top:8px;position:absolute;z-index:10000;border-radius:100px;border:2px solid #f83;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ebfd372","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Franvaro.vue
// module id = 326
// module chunks = 0